<template>
    <div class="selector-sheet__wrapper">
        <p class="selector-sheet__text">
            {{ $t('predictors.americanFootball.predict.pickTeam') }}
        </p>
        <div class="selector-sheet__team-select">
            <team-button
                :src="homeLogo"
                :isSelected="getUserSelectedTeamQualifier === 'home'"
                :userHasParticipated="false"
                :userCanParticipate="true"
                :isSelectorSheet="true"
                type="predict"
                @tap="setSelectedTeamQualifier('home')"
            />
            <team-button
                :src="awayLogo"
                :isSelected="getUserSelectedTeamQualifier === 'away'"
                :userHasParticipated="false"
                :userCanParticipate="true"
                :isSelectorSheet="true"
                type="predict"
                @tap="setSelectedTeamQualifier('away')"
            />
        </div>
        <p class="selector-sheet__team-name">
            {{ selectedTeamName }}
        </p>
        <p class="selector-sheet__text selector-sheet__text--margin">
            {{ $t('predictors.americanFootball.predict.winningPoints') }}
        </p>
        <div class="selector-sheet__points-wrapper">
            <button v-for="(score, index) in scoreRanges"
                :key="index"
                ref="button"
                :class="['selector-sheet__points-button', {
                    'selector-sheet__points-button--selected': userSelectedIndex === index
                }]"
                type="button"
                @click="setUserSelectedIndex(index)"
            >
                {{ score }}
            </button>
        </div>
    </div>
</template>

<script>
// 3rd party
import {
    mapActions,
    mapGetters,
} from 'vuex';

import teamButton from '@webapp/modules/fan-engagement/components/predictor/team-button.vue';

export default {
    name: 'predictor-american-football-sheet',
    components: {
        teamButton,
    },
    props: {
        homeLogo: {
            type: [String, Boolean],
            default: '',
        },
        awayLogo: {
            type: [String, Boolean],
            default: '',
        },
        userChosenTeamQualifier: {
            type: String,
            default: '',
        },
        alternativeCrownLogo: {
            type: String,
            default: '',
        },
        homeTeam: {
            type: Object,
            required: true,
        },
        awayTeam: {
            type: Object,
            required: true,
        },
        scoreRangePredictionId: {
            type: String,
            required: true,
        },
        scoreRanges: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            selectedTeamName: '',
            selectedTeam: {},
        };
    },
    computed: {
        ...mapGetters('predictorTeams', [
            'getCurrentTeam',
            'getTeamPartnerIdById',
        ]),

        ...mapGetters('predictorPredictableSportEvents', [
            'getUserSelectedIndex',
            'getUserSelectedTeamQualifier',
        ]),

        partnerId() {
            return this.getTeamPartnerIdById(this.$route.params.teamId);
        },

        buttonEnabled() {
            return this.getUserSelectedTeamQualifier && this.userSelectedIndex >= 0;
        },

        userSelectedIndex() {
            return this.getUserSelectedIndex;
        },
    },
    watch: {
        buttonEnabled: {
            immediate: true,
            handler(newValue) {
                this.$emit('enableAcceptButton', newValue);
            },
        },
    },
    mounted() {
        if (this.getUserSelectedTeamQualifier) {
            this.setSelectedTeamQualifier(this.getUserSelectedTeamQualifier);
        }
    },
    methods: {
        ...mapActions('predictorTeams', ['fetchTeamById']),

        ...mapActions('predictorSportEvents', ['postAmericanFootballPrediction']),

        ...mapActions('predictorPredictableSportEvents', [
            'setUserSelectedIndex',
            'setUserSelectedTeamQualifier',
        ]),

        setSelectedTeamQualifier(qualifier) {
            this.selectedTeam = qualifier === 'home' ? this.homeTeam : this.awayTeam;

            this.setUserSelectedTeamQualifier(qualifier);

            this.selectedTeamName = this.selectedTeam.name || '';
        },
    },
};
</script>

<style lang="scss" scoped>
.logo {
    height: 20px;
}

.selector-sheet {
    &__wrapper {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: relative;
    }

    &__team-select {
        display: flex;
        gap: 20px;
    }

    &__team-name {
        font-size: 2.1rem;
        font-weight: bold;
    }

    &__text {
        font-size: 1.7rem;
        font-weight: bold;

        &--margin {
            margin-top: 20px;
        }
    }

    &__points-wrapper {
        display: flex;
        gap: 10px;
        padding-bottom: 40px;
    }

    &__points-button {
        cursor: pointer;
        display: block;
        background-color: $blue-dark-color;
        border-style: solid;
        border-width: 1px;
        border-radius: 49px;
        padding: 11px 20px;
        font-size: 1.7rem;
        color: $daintree-color;
        font-weight: bold;
        border-color: $blue-dark-color;
        font-family: "Nunito-Regular", "Nunito", "Sans";

        &--selected {
            border-color: $lime-green-color;
            background-color: $loafer-color;
        }
    }
}
</style>